<template lang="pug">
    include ../helpers/pug/mixins
    +b.rsl-header-top-line
        +e.container
            +e.UL.lang-list(v-if='isLangSwitcherVisible')
                +e.LI.lang-item(
                    v-for='button in langButtons'
                    v-bind:key='button.lang'
                )
                    +e.BUTTON.lang-button(
                        type='button'
                        v-bind:class='{[currentLangClass]: button.lang === currentLang}'
                        v-bind:title='button.title'
                        v-on:click='emitLangButtons(button.lang)'
                    )   {{ button.lang }}
            +e.service-wrapper(
                v-if='isServicesVisible'
                v-click-outside='closeServices'
                v-on:click='toggleServices'
            )
                slot(name='rsl-services')
                +e.BUTTON.service-button(type='button') Сервисы
                    +e.SVG.service-svg(
                        v-bind:width='icons.services.width'
                        v-bind:height='icons.services.height'
                        v-bind:fill='icons.services.fill')
                        title Сервисы
                        use(v-bind:xlink:href='icons.services.xlink')
            +e.user-wrapper(
                v-click-outside='closeUserInfo'
                v-on:click='toggleUserInfo'
                v-if='isAuthorized'
            )
                slot(name='rsl-user-menu')
                +e.BUTTON(type='button').info._is_authorized
                    +e.SPAN.name {{userName}}
                    +e.icon
                        +e.icon-item
                        +e.icon-item
                        +e.icon-item
            +e.login-form(v-else)
                +e.FORM.form(
                    method='get'
                    name='Login RSL'
                    v-bind:action='loginLink'
                )
                    slot(name='loginButton')
                        +e.BUTTON.login-button(type='submit') Вход

</template>

<script>
/**
 * В компоненте используется два слота для передачи контента
 *
 * 1) rsl-services - Модальное выпадающе окно с сервисами // none-required
 *
 * 2) rsl-user-menu - Блок контента с данными о пользователя. // none-required
 *
 */

export default {
    props: {
        isLangSwitcherVisible: {
            type: Boolean,
            required: false,
            default: true
        },
        isServicesVisible: {
            type: Boolean,
            required: false,
            default: true
        },
        isMobile: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
             * Ссылка которую мы передаем в action формы для авторизации
             * @type {String}
             */
        loginLink: {
            type: String,
            required: false,
            default: 'http://localhost:8080/login'
        },
        /**
             * Флаг который говорит нам, авторизован пользователь, или нет
             * @type {Boolean}
             */
        isAuthorized: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
             * Имя пользователя
             * @type {String}
             */
        userName: {
            type: String,
            required: false,
            default: 'Test User'
        },
        /**
             * Принимает на вход объект иконок, которые потом
             * будут отображаться в компоненте. Передавать нужно параметры иконки
             * @type {Object}
             */
        icons: {
            type: Object,
            required: false,
            default() {
                return {
                    services: {
                        xlink: '#services',
                        width: '13px',
                        height: '13px',
                        fill: '#24a2b3'
                    }
                };
            }
        },
        /**
             * Используется для сообщения компоненту, какой язык сейчас используется на сайте
             * по умолчанию 'ru'
             * @type {String}
             */
        currentLang: {
            type: String,
            required: false,
            default: 'ru'
        },
        /**
             * Массив языков который выводится в верхнем меню, принимает на вход массив обьектов.
             * Объект выглядит следующим образом:
             * @param {String} lang - Строковый ключ языка
             * @param {String} title - Описание действие переключения языка на нужном языке, используется для кнопок
             * @type {Array}
             */
        langButtons: {
            type: Array,
            required: false,
            default() {
                return [
                    {
                        lang: 'ru',
                        title: 'Переключиться на русский язык'
                    },
                    {
                        lang: 'en',
                        title: 'Set english language'
                    }
                ];
            }
        }
    },
    data() {
        return {
            currentLangClass: 'rsl-header-top-line__lang-button_current'
        };
    },
    methods: {
        emitLangButtons(lang) {
            this.$emit('update:langButtons', lang);
        },
        toggleServices() {
            this.$emit('toggleServices');
        },
        closeServices() {
            this.$emit('closeServices');
        },
        toggleUserInfo() {
            if (this.isAuthorized) {
                this.$emit('toggleUserInfo');
            }
        },
        closeUserInfo() {
            if (this.isAuthorized) {
                this.$emit('closeUserInfo');
            }
        }
    }
};
</script>

<style lang="sass" src="./rsl-header-top-line.sass"></style>
